import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LandingPage } from './pages/LandingPage';
import CookieConsentBanner from './components/CookieConsentBanner';
import CookiePolicyPage from './pages/CookiePolicyPage';
import './app.css';

const path = window.location.pathname.replace(/\/$/, '');

function App() {
  if (path === '/cookies') return <CookiePolicyPage />;
  return (
    <>
      <LandingPage />
      <CookieConsentBanner />
    </>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
